import Sqids from 'sqids';

function encode<T extends Record<string, number | string>>(
  params: T | (number | string)[],
): string {
  const sqids = new Sqids();

  const numbers: number[] = Object.values(params)
    .map((value) => {
      if (typeof value === 'string') {
        const valueToNumber = Number(value);
        return valueToNumber;
      }

      return value;
    })
    .filter(
      (value) =>
        typeof value === 'number' && !Number.isNaN(value) && value > 0 && Number.isFinite(value),
    );

  const id = sqids.encode(numbers);

  return id;
}

function decode(id: string): number[] {
  const sqids = new Sqids();

  const numbers: number[] = sqids.decode(id);

  return numbers;
}

function hydrate<T extends Record<string, string>>(
  values: string[],
  target: Record<number, keyof T>,
): T {
  const parsed = {} as T;

  Object.entries(target).forEach(([key, value]) => {
    const index = Number(key);

    if (values[index] !== undefined) {
      parsed[value] = String(values[index]) as T[keyof T];
    }
  });

  return parsed;
}

function dehydrate<T extends Record<string, string>, R = string[]>(
  values: T,
  target: Record<number, keyof T>,
): R {
  const parsed: string[] = [];

  Object.entries(target).forEach(([key, value]) => {
    const index = Number(key);

    if (values[value]) {
      parsed[index] = values[value];
    }
  });

  return parsed as R;
}

export const sqids = {
  encode,
  decode,
  hydrate,
  dehydrate,
};
